import { ref, type Ref } from "vue";

type AsyncFun = () => Promise<any>;

export type UseAsyncActionOptions = {
  onError?: (err: unknown) => (void | Promise<void>);
}

export const useAsyncAction = (fun: AsyncFun, options: UseAsyncActionOptions = {}) => {
  const loading: Ref<boolean> = ref(false);
  const error: Ref<InstanceType<typeof Error> | Error | unknown | undefined> = ref(undefined);

  const callAction = async () => {
    loading.value = true;
    try {
      await fun();
    } catch (e) {
      console.error(e);
      error.value = e;
      if (options.onError) {
        options.onError(e);
      }
    }
    loading.value = false;
  }

  const call = () => {
    callAction().catch(e => console.error(e));
  }

  return { call, loading, error };
}
